module.exports = __webpack_public_path__ + "static/media/3.question.d2d94197.mp4";